export default __webpack_public_path__ + "static/media/banner-iadi.41b55cbc.png";